import { securityKey } from "../../../data/SecurityKey";
import { AppIcons } from "../../../data/appIcons";

export const Menu = [
  {
    name: "Dashboard",
    id: "dashboard",
    to: "/",
    image: AppIcons.dashboardMenu,
    Role: [1, 2, 3],
  securityKey: securityKey.DASHBOARD,
    children: [],
  },
  {
    name: "HR Management",
    id: "hrManagement",
    to: "",
    image: AppIcons.hrManagementMenu,
    Role: [1, 2, 3],
    securityKey: securityKey.HRMANAGEMENT,
    children: [
      {
        name: "Candidate List",
        id: "candidateList",
        to: "/CandidateList",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.CANDIDATELIST,
      },
      {
        name: "follow-up Candidates",
        id: "followUp",
        to: "/FollowUp",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.FOLLOWUPCANDIDATE,
      },
      {
        name: "Schedule Interview",
        id: "scheduleInterview",
        to: "/ScheduleInterview",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.SCHEDULEINTERVIEW,
      },
    ],
  },
  // {
  //   name: "System Configuration",
  //   id: "systemConfiguration",
  //   to: "",
  //   image: AppIcons.masterDataMenu,
  //   Role: [1, 2, 3],
  //   children: [

  //     {
  //       name: "Interview Round",
  //       id: "interviewRound",
  //       to: "/InterviewRound",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "Interview Type",
  //       id: "interviewType",
  //       to: "/interviewType",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },

  //     {
  //       name: "Job Position",
  //       id: "position",
  //       to: "/Position",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     // {
  //     //   name: "Manage Skill",
  //     //   id: "ManageSkill",
  //     //   to: "/ManageSkill",
  //     //   image: "",
  //     //   Role: [1, 2, 3],
  //     // },
  //     {
  //       name: "Rejected Reason",
  //       id: "RejectedReason",
  //       to: "/RejectedReason",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     // {
  //     //   name: "Skill Category",
  //     //   id: "skillCategory",
  //     //   to: "/SkillCategory",
  //     //   image: "",
  //     //   Role: [1, 2, 3],
  //     // },
  //     // {
  //     //   name: "Main Skill",
  //     //   id: "mainSkill",
  //     //   to: "/MainSkill",
  //     //   image: "",
  //     //   Role: [1, 2, 3],
  //     // },

  //   ],
  // },
  {
    name: "Manage Questions",
    id: "manageQuestions",
    to: "",
    image: AppIcons.QuestionaryMenu,
    Role: [1, 2, 3],
    securityKey: securityKey.MANAGEQUESTIONS,
    children: [
      {
        name: "Question List",
        id: "questionList",
        to: "/ManageQuestionList",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.QUESTIONSLIST,
      },
    ],
  },

  // {
  //   name: "Security",
  //   id: "SecurityRoleManagement",
  //   image: AppIcons.securityIcon,
  //   to: "/SecurityRoleManagement",
  //   Role: [1, 2, 3],
  //   children: [],
  //   // securityKey: securityKey.SECURITYROLEMANAGEMENT,
  // },
  // {
  //   name: "All Interview",
  //   id: "AllInterview",
  //   to: "/AllInterview",
  //   image: AppIcons.AllInterviewMenu,
  //   Role: [1, 2],
  //   children: [],
  // },
  // {
  //   name: "My Interview",
  //   id: "myInterview",
  //   to: "/MyInterview",
  //   image: AppIcons.AllInterviewMenu,
  //   Role: [3],
  //   children: [],
  // },
  // {
  //   name: "Skills",
  //   id: "skills",
  //   to: "",
  //   image: AppIcons.SkillsMenu,
  //   Role: [1, 2, 3],
  //   children: [
  //     {
  //       name: "Skill Category",
  //       id: "skillCategory",
  //       to: "/SkillCategory",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "Main Skill",
  //       id: "mainSkill",
  //       to: "/MainSkill",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //   ],
  // },
  // {
  //   name: "Management",
  //   id: "management",
  //   to: "",
  //   image: AppIcons.masterDataMenu,
  //   Role: [1, 2, 3],
  //   children: [


  //     {
  //       name: "User Management",
  //       id: "manageUser",
  //       to: "/UserList",
  //       image: "",
  //       Role: [1],
  //     },
  //     {
  //       name: "Email Template",
  //       id: "manageEmail",
  //       to: "/EmailList",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "System Action",
  //       id: "systemAction",
  //       to: "/SystemAction",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "Status",
  //       id: "ProcessStatus",
  //       to: "/StatusList",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "Manage Channel",
  //       id: "manageChannel",
  //       to: "/ManageChannel",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "Manage Source",
  //       id: "manageSource",
  //       to: "/ManageSource",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },
  //     {
  //       name: "Department",
  //       id: "department",
  //       to: "/Department",
  //       image: "",
  //       Role: [1, 2, 3],
  //     },

  //   ],
  // },
  {
    name: "Configure Skills",
    id: "configureSkills",
    to: "",
    image: AppIcons.SkillsMenu,
    Role: [1, 2, 3],
    securityKey: securityKey.CONFIGURESKILLS,
    children: [
      {
        name: "Skill Category",
        id: "skillCategory",
        to: "/SkillCategory",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.SKILLCATEGORY,
      },
      {
        name: "Main Skill",
        id: "mainSkill",
        to: "/MainSkill",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.MAINSKILL,
      },
    ],
  },
  {
    name: "Reports",
    id: "reports",
    to: "",
    image: AppIcons.QuestionaryMenu,
    Role: [1, 2, 3],
    securityKey: securityKey.REPORTS,
    children: [
      {
        name: "Candidate Report",
        id: "candidateReport",
        to: "/CandidateReport",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.CANDIDATEREPORT,
      },
      {
        name: "Job Report",
        id: "jobReport",
        to: "/JobReport",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.JOBREPORT,
      },
      {
        name: "Activity Log Report",
        id: "activitylogReport",
        to: "/ActivitylogReport",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.ACTIVITYLOGREPORT,
      },

    ],
  },
];


export const SystemConfigurationMenu = [
  {
    name: "System Configuration",
    id: "systemConfiguration",
    to: "#",
    image: AppIcons.masterDataMenu,
    securityKey: securityKey.SYSTEMCONFIGURATION,
    Role: [1, 2, 3],
    children: [
      {
        name: "Interview Round",
        id: "interviewRound",
        to: "/SystemConfiguration/InterviewRound",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.INTERVIEWROUND,
      },
      {
        name: "Interview Type",
        id: "interviewType",
        to: "/SystemConfiguration/InterviewType",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.INTERVIEWTYPE,
      },

      {
        name: "Job Position",
        id: "position",
        to: "/SystemConfiguration/Position",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.JOBPOSITION,
      },
      // {
      //   name: "Manage Skill",
      //   id: "ManageSkill",
      //   to: "/ManageSkill",
      //   image: "",
      //   Role: [1, 2, 3],
      // },
      {
        name: "Rejected Reason",
        id: "RejectedReason",
        to: "/SystemConfiguration/RejectedReason",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.REJECTEDREASON,
      },
      // {
      //   name: "Skill Category",
      //   id: "skillCategory",
      //   to: "/SkillCategory",
      //   image: "",
      //   Role: [1, 2, 3],
      // },
      // {
      //   name: "Main Skill",
      //   id: "mainSkill",
      //   to: "/MainSkill",
      //   image: "",
      //   Role: [1, 2, 3],
      // },
      {
        name: "Followup Reason",
        id: "FollowupReason",
        to: "/SystemConfiguration/FollowupReason",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.FOLLOWUPREASON,
      },
      {
        name: "Security",
        id: "SecurityRoleManagement",
        image: AppIcons.securityIcon,
        to: "/SystemConfiguration/SecurityRoleManagement",
        Role: [1, 2, 3],
        children: [],
        securityKey: securityKey.SECURITY,
      },
    ],
  },
  {
    name: "Management",
    id: "management",
    to: "#",
    image: AppIcons.masterDataMenu,
    Role: [1, 2, 3],
    securityKey: securityKey.MANAGEMENT,
    children: [


      {
        name: "User Management",
        id: "manageUser",
        to: "/SystemConfiguration/UserList",
        image: "",
        Role: [1],
        securityKey: securityKey.USERMANAGEMENT,
      },
      {
        name: "Email Template",
        id: "manageEmail",
        to: "/SystemConfiguration/EmailList",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.EMAILTEMPLATE,
      },
      {
        name: "System Action",
        id: "systemAction",
        to: "/SystemConfiguration/SystemAction",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.SYSTEMACTION,
      },
      {
        name: "Status",
        id: "ProcessStatus",
        to: "/SystemConfiguration/StatusList",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.STATUS,
      },
      {
        name: "Manage Channel",
        id: "manageChannel",
        to: "/SystemConfiguration/ManageChannel",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.MANAGECHANNEL,
      },
      {
        name: "Manage Source",
        id: "manageSource",
        to: "/SystemConfiguration/ManageSource",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.MANAGESOURCE,
      },
      {
        name: "Department",
        id: "department",
        to: "/SystemConfiguration/Department",
        image: "",
        Role: [1, 2, 3],
        securityKey: securityKey.DEPARTMENT,
      },

    ],
  },
];